export default "__VITE_ASSET__CRb1jRLp__"